module.exports = __webpack_public_path__ + "static/raleway-medium-ada3d60c831cee3da6f0619ea1f5aaf1.woff2";